import { Box, makeStyles } from "@material-ui/core";
import React, { useEffect, useMemo, useState } from "react";
import assets from "../../../helpers/assets";
import Colors from "../../../helpers/Colors";
import { orderDispatch } from "../../../services/OrderService";
import Text from '../Text';

const DispatchButton = ({ orderId, statusHistory }) => {
    const [onHover, setHover] = useState(false);
    const [dispatchEnabled, setDispatchEnabled] = useState(false);
    const [requestSent, setRequestSent] = useState(false);

    const classes = useStyles();

    useEffect(() => {
        if (!statusHistory) return;
        const readyToDispatch = statusHistory.find((item) => {
            return item.status === 'READY_TO_DISPATCH';
        });
        setDispatchEnabled(readyToDispatch);
    }, [JSON.stringify(statusHistory)])

    const dispatchOrder = () => {
        if (dispatchEnabled && !requestSent) {
            setRequestSent(true);
            setDispatchEnabled(false);
            orderDispatch(orderId)
                .then((response) => {
                })
                .catch((error) => {
                    setRequestSent(false);
                    setDispatchEnabled(true);
                    console.log('Dispatch error', error);
                });
        }
    }

    return useMemo(() => {
        return (
            <Box
                onMouseEnter={() => {
                    if (dispatchEnabled) {
                        setHover(true);
                    }
                }}
                onMouseLeave={() => setHover(false)}
                onClick={dispatchOrder}
                className={dispatchEnabled ? classes.buttonContentContainer : classes.disabledButtonContentContainer}
            >
                <img
                    src={requestSent ? assets.tick.default : assets.dispatch.default}
                    alt=""
                    className={classes.dispatchIcon}
                />
                {onHover && (
                    <Text className={classes.dispatchButtonLabel}>{requestSent ? 'DISPATCHING..' : 'DISPATCH'}</Text>
                )}
            </Box>
        )
    }, [dispatchEnabled, onHover, requestSent]);

}

export default DispatchButton;



const useStyles = makeStyles((theme) => ({
    dispatchIcon: {
        height: 32,
        width: 32,
        objectFit: 'contain',
    },
    dispatchButtonLabel: {
        marginLeft: 20,
        color: Colors.white,
        fontSize: 18,
        fontFamily: 'DINNextLTPro-Regular',
    },
    buttonContentContainer: {
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: Colors.boldBlue,
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
    disabledButtonContentContainer: {
        cursor: 'pointer',
        minHeight: 40,
        maxHeight: 40,
        paddingLeft: 15,
        paddingRight: 15,
        backgroundColor: 'rgba(25, 136, 252, 0.3)',
        borderRadius: 4,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
    },
}));
